export const IDENTITY_CONFIG = {
  authority: process.env.REACT_APP_AUTH_URL,
  client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URL,
  automaticSilentRenew: true,
  loadUserInfo: false,
  silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL,
  post_logout_redirect_uri: process.env.REACT_APP_LOGOFF_REDIRECT_URL,
  response_type: 'id_token token',
  scope: 'openid profile roles api all_claims rdb_api',
  acr_values: `tenant:${process.env.REACT_APP_TENANT_ID}`,
  // silentRequestTimeout: 2 * 60 * 1000,
};

export const METADATA_OIDC = {
  issuer: process.env.REACT_APP_AUTH_URL,
  jwks_uri:
    process.env.REACT_APP_AUTH_URL + '/.well-known/openid-configuration/jwks',
  authorization_endpoint: process.env.REACT_APP_AUTH_URL + '/connect/authorize',
  token_endpoint: process.env.REACT_APP_AUTH_URL + '/connect/token',
  userinfo_endpoint: process.env.REACT_APP_AUTH_URL + '/connect/userinfo',
  end_session_endpoint: process.env.REACT_APP_AUTH_URL + '/connect/endsession',
  check_session_iframe:
    process.env.REACT_APP_AUTH_URL + '/connect/checksession',
  revocation_endpoint: process.env.REACT_APP_AUTH_URL + '/connect/revocation',
  introspection_endpoint:
    process.env.REACT_APP_AUTH_URL + '/connect/introspect',
};

export const AUTH_TOKEN = 'AUTH_TOKEN';
export const SILENT_SIGN_IN_LOADING = 'SILENT_SIGN_IN_LOADING';
export const LOGIN_TYPE = 'LOGIN_TYPE';
export const LOGIN_TYPES = {
  FIRST_LOGIN: 'FIRST_LOGIN', // user landed on any page without token
  REFRESH_LOGIN: 'REFRESH_LOGIN', // token expired while user was working in a page
};
